/** Traductions page inventaire simplifié (FR / AR) */
export const inventoryPageFr = {
  productsAddedSuccess: '{{count}} produit(s) ajouté(s) avec succès',
  productUpdatedSuccess: 'Produit mis à jour avec succès',
  loading: 'Chargement des données...',
  reportTitle: 'Rapport Produits - {{date}}',
  reportTotalProducts: 'Total Produits',
  reportProductsInStock: 'Produits en Stock',
  reportOutOfStock: 'Rupture de Stock',
  reportTotalStockValue: 'Valeur Totale du Stock',
  importExcel: 'Importer Excel',
  importSuccess: 'Import Excel terminé',
  saveError: 'Enregistrement du produit impossible',
  addDish: 'Ajouter Plat',
  addIngredient: 'Ajouter Ingrédient',
  addProduct: 'Ajouter Produit',
  dishesTab: 'Plats menu',
  ingredientsTab: 'Ingrédients',
  productsTab: 'Produits',
  evaluationTab: 'Évaluation',
  searchLabel: 'Recherche',
  searchPlaceholder: 'Rechercher un produit...',
  categoryLabel: 'Catégorie',
  allCategories: 'Toutes les catégories',
  subcategoryLabel: 'Sous-catégorie',
  allSubcategories: 'Toutes les sous-catégories',
  typeLabel: 'Type',
  allTypes: 'Tous les types',
  showEmptyStock: 'Afficher stock vide',
  resetFilters: 'Reset',
  calculatingStock: 'Calcul du stock en cours...',
  productList: 'Liste des Produits',
  colProduct: 'Produit',
  colQuantity: 'Quantité',
  colPurchasePrice: 'Prix d\'achat unit.',
  colSellingPrice: 'Prix de vente',
  colValue: 'Valeur',
  colActions: 'Actions',
  dishNotApplicable: '—',
  dishNoStockHint: 'Plat menu — vente directe, pas de stock',
  dishNoPurchaseHint: 'Plat menu — pas d\'achat ni de stock',
  dishNoValueHint: 'Plat menu — pas de valeur de stock',
  quantityFromLotsHint: 'Quantité calculée depuis les lots — non modifiable',
  purchasePriceFromPurchasesHint: 'Prix d\'achat issu des achats — modifiable uniquement dans Achats',
  sellingPriceFromLotsHint: 'Prix de vente du catalogue, sinon du dernier lot / achat',
  editProduct: 'Modifier Produit',
  totalValue: 'Valeur Totale',
  filtered: 'filtré',
  potentialProfit: 'Profit Potentiel',
  evaluationByCategory: 'Évaluation par Catégorie',
  noFilterMatch: 'Aucune donnée ne correspond aux filtres sélectionnés',
  emptyProductList: 'Aucun produit à afficher',
  skuLabel: 'SKU',
  printPriceLabels: 'Imprimer les étiquettes prix'
};

export const inventoryPageAr = {
  productsAddedSuccess: 'تم إضافة {{count}} منتج بنجاح',
  productUpdatedSuccess: 'تم تحديث المنتج بنجاح',
  loading: 'جاري تحميل البيانات...',
  reportTitle: 'تقرير المنتجات - {{date}}',
  reportTotalProducts: 'إجمالي المنتجات',
  reportProductsInStock: 'المنتجات في المخزون',
  reportOutOfStock: 'نفد المخزون',
  reportTotalStockValue: 'إجمالي قيمة المخزون',
  importExcel: 'استيراد من Excel',
  importSuccess: 'اكتمل استيراد Excel',
  saveError: 'تعذر حفظ المنتج',
  addDish: 'إضافة طبق',
  addIngredient: 'إضافة مكوّن',
  addProduct: 'إضافة منتج جديد',
  dishesTab: 'الأطباق (القائمة)',
  ingredientsTab: 'المكونات',
  productsTab: 'المنتجات',
  evaluationTab: 'التقييم',
  searchLabel: 'البحث',
  searchPlaceholder: 'ابحث عن منتج بالاسم أو الرمز...',
  categoryLabel: 'الفئة',
  allCategories: 'جميع الفئات',
  subcategoryLabel: 'الفئة الفرعية',
  allSubcategories: 'جميع الفئات الفرعية',
  typeLabel: 'النوع',
  allTypes: 'جميع الأنواع',
  showEmptyStock: 'إظهار المنتجات ذات المخزون الفارغ',
  resetFilters: 'إعادة تعيين الفلاتر',
  calculatingStock: 'جاري حساب المخزون...',
  productList: 'قائمة المنتجات',
  colProduct: 'المنتج',
  colQuantity: 'الكمية',
  colPurchasePrice: 'سعر الشراء للوحدة',
  colSellingPrice: 'سعر البيع',
  colValue: 'القيمة',
  colActions: 'الإجراءات',
  dishNotApplicable: '—',
  dishNoStockHint: 'طبق قائمة — بيع مباشر بدون مخزون',
  dishNoPurchaseHint: 'طبق قائمة — بدون شراء ولا مخزون',
  dishNoValueHint: 'طبق قائمة — بدون قيمة مخزون',
  quantityFromLotsHint: 'الكمية محسوبة من الدُفعات — لا يمكن التعديل اليدوي',
  purchasePriceFromPurchasesHint: 'سعر الشراء من المشتريات — يُعدّل فقط في صفحة المشتريات',
  sellingPriceFromLotsHint: 'سعر البيع من الكتالوج، وإلا من آخر دفعة / شراء',
  editProduct: 'تعديل المنتج',
  totalValue: 'القيمة الإجمالية',
  filtered: 'مفلتر',
  potentialProfit: 'الربح المحتمل',
  evaluationByCategory: 'التقييم حسب الفئة',
  noFilterMatch: 'لا توجد بيانات تتطابق مع الفلاتر المحددة',
  emptyProductList: 'لا توجد منتجات للعرض',
  skuLabel: 'SKU',
  printPriceLabels: 'طباعة ملصقات الأسعار'
};
